import { LanguageSwitch } from "@/components/countries/norway/LanguageSwitch";
import SelectByLocale from "@/components/SelectByLocale";
import { I18nCountry } from "@/types/types";

type LocalizedLanguageSwitchProps = {
  theme?: "light" | "dark";
  className?: string;
};

const LocalizedLanguageSwitch = ({
  className,
  theme,
}: LocalizedLanguageSwitchProps) => {
  return (
    <SelectByLocale visibleIfCountry={I18nCountry.NO}>
      <LanguageSwitch className={className} theme={theme} />
    </SelectByLocale>
  );
};

export default LocalizedLanguageSwitch;
